import {
  ADD_PROMOCODE_START,
  ADD_PROMOCODE_SUCCESS,
  ADD_PROMOCODE_ERROR
} from '../../../constants';
import history from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../../actions/loader/loader';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { addPromoCodeMutation } from '../../../lib/graphql';

export const addPromoCode = (values) => {
  return async (dispatch, getState, { client }) => {
    try {
      let requestContent = {},
        status, errorMessage = 'Oops! something went wrong! Please try again.';
      dispatch({
        type: ADD_PROMOCODE_START,
        payload: {
          promoCodeLoading: true
        }
      });

      dispatch(setLoaderStart('AddPromoCode'));

      const mutation = addPromoCodeMutation;
      if (!values.id) values.isEnable = true;

      const { data } = await client.mutate({
        mutation,
        variables: {
          id: values?.id,
          title: values?.title,
          description: values?.description,
          code: values?.code,
          type: values?.type,
          promoValue: values?.promoValue,
          currency: values?.currency,
          expiryDate: values && values.expiryDate && values.expiryDate !== '' ? values.expiryDate : null,
          isEnable: values && values.isEnable.toString() === "true",
          imageName: values?.imageName
        }
      });

      if (data) {
        status = data?.addPromoCode?.status;
        errorMessage = data?.addPromoCode?.errorMessage;
      }

      dispatch(setLoaderComplete('AddPromoCode'));

      if (status !== 200) {
        requestContent = {
          content: errorMessage
        };
        showToaster({ messageId: 'errorMessage', requestContent, toasterType: 'error' });
        dispatch({
          type: ADD_PROMOCODE_ERROR,
          payload: {
            promoCodeLoading: false,
            error: errorMessage
          }
        });
        return '';
      }

      history.push('/siteadmin/promo-code/list');
      requestContent = {
        id: values && values.id
      };
      showToaster({ messageId: 'addPromoCodeSuccess', requestContent, toasterType: 'success' });
      await dispatch({
        type: ADD_PROMOCODE_SUCCESS,
        payload: {
          promoCodeLoading: false
        }
      });

      dispatch(setLoaderComplete('AddPromoCode'));
    }
    catch (error) {
      dispatch(setLoaderComplete('AddPromoCode'));
      let requestContent = {
        content: error
      };
      showToaster({ messageId: 'catchMessage', requestContent, toasterType: 'error' });
      await dispatch({
        type: ADD_PROMOCODE_ERROR,
        payload: {
          promoCodeLoading: false,
          error
        }
      });
    }
  }
}